<template>
  <div :class="bem()">
    <div
      :class="bem('detail-row', {'shipping-row': true})"
    >
      <span :class="bem('detail-row-title')">Shipping</span>
      <div :class="bem('detail-row-result-container', {'loading': shopifyStore.loading})">
        <span
          :class="bem('detail-row-result',
                      {'shipping': props.hasFreeShipping,
                       'small': (!props.hasFreeShipping && !shopifyStore.totalShippingCost)})"
        >
          <template v-if="props.hasFreeShipping">
            FREE
          </template>
          <template v-else-if="shopifyStore.totalShippingCost">
            {{ $tcl(shopifyStore.totalShippingCost) }}
          </template>
          <template v-else>
            Calculated at checkout
          </template>
        </span>
      </div>
    </div>

    <div
      v-if="storefrontStore.isDDP"
      :class="bem('shipping-notification-message')"
    >
      {{ storefrontStore.shippingNotificationMessage }}
    </div>
    
    <p
      v-if="hasPrescriptionItem"
      :class="bem('prescription-note')"
    >
      {{
        $tr(
          "Upload your prescription directly after checkout, or share it later via an email link we'll send you."
        )
      }}
    </p>

    <CartCouponCode v-if="shopifyStore.totalDiscount" />

    <CartGiftCard
      v-if="shopifyStore.giftCard"
    />
  </div>
</template>

<script setup lang="ts">

const bem = useBEM('CartSidebarInfo')
const shopifyStore = useShopifyStore() as any
const storefrontStore = useStorefrontStore()

const props = defineProps({
  hasFreeShipping: Boolean,
})

const hasPrescriptionItem = computed(() => {
  return !!Object.entries(shopifyStore.bundledCartItems)
  .filter(([_bundleId, bundle]: [any, any]) => bundle.summary?.bundleIsPrescription === true).length
})
</script>

<style lang="postcss">
.CartSidebarInfo {
  @apply grid grid-cols-1 gap-2 px-[var(--cart-inline-padding)];
}

.CartSidebarInfo__detail-row {
  @apply flex justify-between gap-4 items-center;
}

.CartSidebarInfo__detail-row-title {
  @apply text-grey-500 text-xs whitespace-nowrap grow;

  &--small {
    @apply text-[11px]
  }
}

.CartSidebarInfo__detail-row-result-container {
  @apply overflow-clip relative;

  &--loading {
    .CartSidebarInfo__detail-row-result {
      @apply translate-y-full;
    }
  }
}

.CartSidebarInfo__detail-row-result {
  @apply block font-bold text-xs translate-y-0 transition-transform duration-300;

  &--shipping {
    @apply text-green;
  }

  &--small {
    @apply font-thin text-[11px] text-grey-500;
  }
}

.CartSidebarInfo__prescription-note {
  @apply text-grey-500 text-xs;
}

.CartSidebarInfo__shipping-notification-message {
  @apply text-xs text-grey-500;
}
</style>
